import React, { useEffect, useRef, useState } from 'react';
import { Modal } from "react-bootstrap";
import isNull from '../../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../../utils/FormValidator';
import ModalHeader from '../../../../../../../../../../../Setup/Shared/ModalHeader';
import Loader from '../../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../../General/DeleteConfirmation';

const AddNewDevelopmentHistory = (props) => {
    const { isOpenDevelopmentHistory, onClose, developmentHistoryData, setIsRecordSaved, patientID, IsEditAllowed, onDeleteDevelopmentHistory } = { ...props }
    const API_URL = enumUtil.controller.General
    let DevelopmentHistory_Modal = {
        Notes: developmentHistoryData.Notes || "",
    }
    let DevelopmentHistory_Modal_Default = {
        Notes: "",
    }
    let valModal = {}
    let ValidationModal = {
        NotesVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [developmentHistoryID, setDevelopmentHistoryID] = useState();
    const [developmentHistoryValidationModal, setDevelopmentHistoryValidationModal] = useState(ValidationModal)
    const [developmentHistorySaveUpdateModal, setDevelopmentHistorySaveUpdateModal] = useState({})
    const [mainDevelopmentHistoryModal, setMainDevelopmentHistoryModal] = useState(DevelopmentHistory_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onDevelopmentHistorySaved, setOnDevelopmentHistorySaved] = useState(false)
    const [del, setDel] = useState(false)
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);

    useEffect(() => {
        // setPracticeID(PracticeID)
        if (developmentHistoryData.PatientHistoryID != null) {
            setDel(true)
            setDevelopmentHistoryID(developmentHistoryData.PatientHistoryID)
        } else {
            if (!onDevelopmentHistorySaved) {
                setDevelopmentHistoryID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(developmentHistoryID)) {
        }
    }, [developmentHistoryID])

    const DevelopmentHistoryValidation = async () => {
        let ValidationModal = {
            NotesVal: FormValidator(
                mainDevelopmentHistoryModal.Notes,
                enumUtil.enumValidationType.Required,
                'Notes',
            ),
        }
        await setDevelopmentHistoryValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const addNewDevelopmentHistory = () => {
        props.setDevelopmentHistoryData({ PatientHistoryID: null })
        setDevelopmentHistoryID(null)
        handleClear();
    }
    const handleSaveDevelopmentHistory = async (type) => {
        if(!IsEditAllowed) return;
        await DevelopmentHistoryValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setDevelopmentHistorySaveUpdateModal(developmentHistorySaveUpdateModal)
            let data = {
                PatientID: patientID,
                HistoryType: "Past Medical History",
                HistorySubType: "Development History",
                ...developmentHistorySaveUpdateModal
            };

            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientHistory,
                ID: developmentHistoryID,
                Data: { ...data },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setIsRecordSaved(true)
                        setDevelopmentHistoryID(response.id)
                        setOnDevelopmentHistorySaved(true);
                        if (type === "Add Another") {
                            addNewDevelopmentHistory();
                        } else {
                            onClose();
                        }
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleClear = () => {
        setMainDevelopmentHistoryModal(DevelopmentHistory_Modal_Default);
        setDevelopmentHistorySaveUpdateModal({});
    }
    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainDevelopmentHistoryModal };
        let saveModal = { ...developmentHistorySaveUpdateModal }
        modal[name] = value
        setMainDevelopmentHistoryModal(modal)
        for (var property in DevelopmentHistory_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setDevelopmentHistorySaveUpdateModal(saveModal)
    }

    const DevelopmentHistoryName = () => {
        return (
            <p className="heading">Past Medical History</p>
        )
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        props?.setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }

    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientHistory}
                ID={String(developmentHistoryID)}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.setProperty('height', 'auto', 'important');
            textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
        }
    };
    useEffect(() => {
        adjustTextareaHeight();
    }, [mainDevelopmentHistoryModal.Notes]);

    return (
        <Modal show={isOpenDevelopmentHistory} onHide={isOpenDevelopmentHistory} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={DevelopmentHistoryName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="">
                    <div className=''>
                        <div className={`input my-2 ${developmentHistoryValidationModal.NotesVal ? 'error' : ''}`}>
                            <label className="pb-3px">Development History</label>
                            <textarea
                                className="form-control overflow-hidden"
                                ref={textareaRef}
                                onInput={adjustTextareaHeight}
                                id='Notes'
                                name='Notes'
                                rows="3"
                                onChange={handleChange}
                                value={mainDevelopmentHistoryModal.Notes}
                            />
                            {developmentHistoryValidationModal.NotesVal}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <div className="d-flex align-items-center gap-2">
                <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleSaveDevelopmentHistory("Add Another")}>Save & Add Another</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveDevelopmentHistory}>Save</button>
                </div>
            </div>
        </Modal>
    )
}

export default AddNewDevelopmentHistory